module.exports = __webpack_public_path__ + "img/downtxt.3ffc2103.png";